export default "__VITE_ASSET__a8ad0498__"